export default __webpack_public_path__ + "static/home-graphic-image-b0bc9a24369cc8c439c949cb570fcddc.png";